export default __webpack_public_path__ + "static/dfh-pattern-gray-a9ac1402f8eb2ca001da310467730f69.svg";